import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const router = new Router({
  routes: [
    //路由懒加载
    {
      path: "/",
      component: (resolve) => require(["./view/buyer/join.vue"], resolve),
      redirect: "/join",
      children: [
        {
          path: "/join",
          component: (resolve) => require(["./view/buyer/join.vue"], resolve),
          meta: { title: "如何加盟", keepAlive: false },
        },
      ],
    },
    {
      path: "/adSense",
      component: (resolve) => require(["./view/buyer/adSense.vue"], resolve),
      meta: { 
        title: "投放广告",
        keepAlive: false
      }
    },
    {
      path: "/note",
      component: (resolve) => require(["./view/buyer/note.vue"], resolve),
      meta: { title: "免单规则", keepAlive: true },
    },
    {
      path: "/success",
      component: (resolve) => require(["./view/buyer/success.vue"], resolve),
      meta: { title: "提交成功", keepAlive: false },
    },
    {
      path: "/wxsuccess",
      component: (resolve) => require(["./view/buyer/wxsuccess.vue"], resolve),
      meta: { title: "提交成功", keepAlive: false },
    },
    {
      path: "/record",
      component: (resolve) => require(["./view/buyer/record.vue"], resolve),
    },
    {
      path: "/joinup",
      component: (resolve) => require(["./view/buyer/joinup.vue"], resolve),
      meta: { title: "商家注册", keepAlive: false },
    },
    {
      path: "/rule",
      component: (resolve) => require(["./view/buyer/rule.vue"], resolve),
      meta: { title: "悦买用户协议", keepAlive: true },
    },
    {
      path: "/payText",
      component: (resolve) => require(["./view/buyer/payText.vue"], resolve),
      meta: { title: "手续费费用说明", keepAlive: true },
    },
    {
      path: "/deliveryMap",
      component: (resolve) => require(["./view/buyer/deliveryMap.vue"], resolve),
      meta: { title: "配送详情", keepAlive: false },
    },
    {
      path: "/help",
      component: (resolve) => require(["./view/buyer/help.vue"], resolve),
      meta: { title: "客服中心", keepAlive: false },
    },
    {
      path: "/myScore",
      component: (resolve) => require(["./view/picker/myScore.vue"], resolve),
      meta: { title: "我的评分", keepAlive: false },
    },
    {
      path: "/complaintRecord",
      component: (resolve) => require(["./view/picker/complaintRecord.vue"], resolve),
      meta: { title: "投诉记录", keepAlive: false },
    },
    {
      path: "/includeDetail",
      component: (resolve) => require(["./view/picker/includeDetail.vue"], resolve),
      meta: { title: "收入明细", keepAlive: false },
    },
    // {
    //   path: "/deductionDetail",
    //   component: resolve => require(["./view/picker/deductionDetail.vue"], resolve),
    //   meta: { title: "扣款详情", keepAlive: true }
    // },
    {
      path: "/complaintHandDetails",
      component: (resolve) => require(["./view/picker/complaintHandDetails.vue"], resolve),
      meta: { title: "投诉处理详情", keepAlive: false },
    },
    {
      path: "/orderIncludeDetail",
      component: (resolve) => require(["./view/picker/orderIncludeDetail.vue"], resolve),
      meta: { title: "正常订单收入详情", keepAlive: false },
    },
    {
      path: "/withdrawalRecords",
      component: (resolve) => require(["./view/picker/withdrawalRecords.vue"], resolve),
      meta: { title: "提现记录", keepAlive: false },
    },
    {
      path: "/withdrawalDetail",
      component: (resolve) => require(["./view/picker/withdrawalDetail.vue"], resolve),
      meta: { title: "提现详情", keepAlive: false },
    },
    {
      path: "/myAssess",
      component: (resolve) => require(["./view/buyer/myAssess.vue"], resolve),
      meta: { title: "我的评价", keepAlive: false },
    },
    {
      path: "/questionnaires",
      component: (resolve) => require(["./view/buyer/questionnaires.vue"], resolve),
      meta: { title: "小问卷", keepAlive: false },
    },
    {
      path: "/role",
      component: (resolve) => require(["./view/picker/role.vue"], resolve),
      meta: { title: "用户协议", keepAlive: true },
    },
    {
      path: "/roles",
      component: (resolve) => require(["./view/picker/roles.vue"], resolve),
      meta: { title: "选菜妈妈用户协议", keepAlive: true },
    },
    {
      path: "/invite",
      component: (resolve) => require(["./view/picker/invite.vue"], resolve),
      meta: { title: "邀请分享", keepAlive: false },
    },
    {
      path: "/appCourse",
      component: (resolve) => require(["./view/picker/appCourse.vue"], resolve),
      meta: { title: "选菜师教程", keepAlive: false },
    },
    {
      path: "/aboutUs",
      component: (resolve) => require(["./view/picker/aboutUs.vue"], resolve),
      meta: { title: "关于我们", keepAlive: false },
    },
    {
      path: "/jionPicker",
      component: (resolve) => require(["./view/buyer/jionPicker.vue"], resolve),
      meta: { title: "选菜妈妈", keepAlive: false },
    },
    {
      path: "/payDetail",
      component: (resolve) => require(["./view/picker/payDetail.vue"], resolve),
      meta: { title: "支付详情", keepAlive: false },
    },
    {
      path: "/reportDetail",
      component: (resolve) => require(["./view/picker/reportDetail.vue"], resolve),
      meta: { title: "举报详情", keepAlive: false },
    },
    {
      path: "/complaintReply",
      component: (resolve) => require(["./view/picker/complaintReply.vue"], resolve),
      meta: { title: "投诉回复", keepAlive: false },
    },
    {
      path: "/commisDetails",
      component: (resolve) => require(["./view/picker/commisDetails.vue"], resolve),
      meta: { title: "采购金详情", keepAlive: false },
    },
    {
      path: "/exclusiveWelfare",
      component: (resolve) => require(["./view/buyer/exclusiveWelfare.vue"], resolve),
      meta: { title: "专属红包", keepAlive: false },
    },
    {
      path: "/campaignSpending",
      component: (resolve) => require(["./view/seller/campaignSpending.vue"], resolve),
      meta: { title: "分享商品支出金额明细", keepAlive: false },
    },
    {
      path: "/selleRule",
      component: (resolve) => require(["./view/seller/rule.vue"], resolve),
      meta: { title: "喜悦发布用户协议", keepAlive: false },
    },
    {
      path: "/ysText",
      component: (resolve) => require(["./view/seller/ysText.vue"], resolve),
      meta: { title: "悦卖隐私政策", keepAlive: false },
    },
    {
      path: "/ysText2",
      component: (resolve) => require(["./view/picker/ysText.vue"], resolve),
      meta: { title: "选菜师隐私政策", keepAlive: false },
    },
    {
      path: "/ysText3",
      component: (resolve) => require(["./view/buyer/ysText.vue"], resolve),
      meta: { title: "悦买隐私政策", keepAlive: false },
    },
    {
      path: "/workBack",
      component: (resolve) => require(["./view/buyer/workFeedback.vue"], resolve),
      meta: { title: "作品反馈", keepAlive: false },
    },
    {
      path: "/sellerBye",
      component: (resolve) => require(["./view/seller/sellerBye.vue"], resolve),
      meta: { title: "注销账号协议", keepAlive: false },
    },
    {
      path: "/mini",
      component: (resolve) => require(["./view/app/mini.vue"], resolve),
      meta: { title: "快捷方式", keepAlive: false },
    },
    // {withdrawalDetail
    //   path: "/noCodeRule",
    //   component: resolve => require(["./view/buyer/noCodeRule.vue"], resolve)
    // },
    // { path: "/help", component: resolve => require(["./view/buyer/help.vue"], resolve) }
  ],
});

export default router;
